module.exports = __webpack_public_path__ + "static/image/logo-family/logo_one@3x.png?7badd415";